/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Row_GoalInputs */

const en_us2_profile_row_goal = /** @type {(inputs: Profile_Row_GoalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Main goal`)
};

const pt_br2_profile_row_goal = /** @type {(inputs: Profile_Row_GoalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Objetivo principal`)
};

const es_419_profile_row_goal = /** @type {(inputs: Profile_Row_GoalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Objetivo principal`)
};

const pt_pt2_profile_row_goal = /** @type {(inputs: Profile_Row_GoalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Objetivo principal`)
};

const fr_fr2_profile_row_goal = /** @type {(inputs: Profile_Row_GoalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Objectif principal`)
};

const de_de2_profile_row_goal = /** @type {(inputs: Profile_Row_GoalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hauptziel`)
};

const it_it2_profile_row_goal = /** @type {(inputs: Profile_Row_GoalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obiettivo principale`)
};

/**
* | output |
* | --- |
* | "Main goal" |
*
* @param {Profile_Row_GoalInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_row_goal = /** @type {((inputs?: Profile_Row_GoalInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Row_GoalInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_row_goal(inputs)
	if (locale === "es-419") return es_419_profile_row_goal(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_row_goal(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_row_goal(inputs)
	if (locale === "de-DE") return de_de2_profile_row_goal(inputs)
	if (locale === "it-IT") return it_it2_profile_row_goal(inputs)
	return en_us2_profile_row_goal(inputs)
});
export { profile_row_goal as "profile.row_goal" }